import React, {useEffect} from "react";
import Box from "@mui/material/Box";
import Heading from "../../../components/shared/Heading";
import {Grid} from "@mui/material";
import Report from "./Report";
import Panel from "./Panel";
import {useLocation} from "react-router-dom";
import {REPORT_TYPE_TAB} from "../index";

interface TabPanelProps {
    children?: React.ReactNode;
    dir?: string;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{p: 3}}>
                    {children}
                </Box>
            )}
        </div>
    );
}

export const Acessos = () => {
    // const history = useHistory();
    const location = useLocation();
    const [tabSelected, setTabSelected] = React.useState<any>(REPORT_TYPE_TAB.REPORT);

    // const handleSelectTab = (value: number) => {
    //     setTabSelected(value);
    //     const param = value === 0 ? 'panel' : 'report';
    //     history.push({search: `?type=${param}`});
    // }

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const type = params.get('type');
        if (type === 'panel') {
            setTabSelected(REPORT_TYPE_TAB.PANEL);
        } else if (type === 'report') {
            setTabSelected(REPORT_TYPE_TAB.REPORT);
        }
    }, [location.search]);

    return (
        <Grid container spacing={2}>
            <Heading
                as={"h1"}
                size={"large"}
                font={"Campuni"}
                style={{marginRight: "40px", marginLeft: "40px"}}
            >
                Acessos
            </Heading>
            {/*<ToggleButtonGroup>*/}
            {/*    <Button selected={tabSelected === 0} onClick={() => handleSelectTab(0)}>*/}
            {/*        Painel visual*/}
            {/*    </Button>*/}
            {/*    <Button selected={tabSelected === 1} onClick={() => handleSelectTab(1)}>*/}
            {/*        Relatórios*/}
            {/*    </Button>*/}
            {/*</ToggleButtonGroup>*/}
            <Grid item xs={12} md={12}>
                <TabPanel value={tabSelected} index={0}>
                    <Panel/>
                </TabPanel>

                <TabPanel value={tabSelected} index={1}>
                    <Report/>
                </TabPanel>
            </Grid>
        </Grid>
    );
};
